import React, {Component} from 'react';
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import WalletEmpty from "../../assets/images/icon-Bold-Wallet.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus , faCoins} from '@fortawesome/free-solid-svg-icons'
import API from "../../services/API";
const currencyFormat = Intl.NumberFormat('en-US');
class Wallet extends Component {
    state = {
        wallet_inventory: 0,
        transactions: []
    }

    render() {
        return (
            <React.Fragment>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>
                            <div className="text-center mt-5 text-secondary">
                                <h2 >
                                    <strong>کیف پول</strong>
                                </h2>
                            </div>
                            <section className="container rtl mt-5 p-3 usual-content ">
                                <div className="row">
                                    <div className="col-12 text-left ">
                                        <div className="wallet-inventory">
                                            <FontAwesomeIcon icon={faCoins}/>
                                            &nbsp;
                                            موجودی کیف پول شما:
                                            &nbsp;
                                            <strong>
                                                {currencyFormat.format(this.state.wallet_inventory)}
                                            </strong>
                                            &nbsp;
                                            {window.localStorage.getItem("currency_unit")}
                                        </div>
                                        <button className="btn btn-primary"
                                                onClick={() => this.props.history.push('/contents/guide-receive-credit')}>
                                            <FontAwesomeIcon icon={faPlus}/>
                                            &nbsp;
                                            افزایش شارژ کیف پول
                                        </button>
                                    </div>
                                    {
                                        this.state.transactions.length > 0 ?
                                            <React.Fragment>
                                                <div className='row text-center py-3 m-auto mt-5 transactions-header  '  >
                                                    <div className="col-3">مبلغ تراکنش</div>
                                                    <div className="col-6">توضیحات</div>
                                                    <div className="col-3">تاریخ</div>

                                                </div>
                                                {
                                                    this.state.transactions.map(tr => {
                                                        if(tr.decrease_amount <= 0) {
                                                            return(
                                                                <div className='row text-center text-success py-3 m-auto mt-2 transactions-body  '  >
                                                                    <div className="col-3 fw-bold">
                                                                        {  currencyFormat.format(tr.increase_amount)}
                                                                        &nbsp;
                                                                        {window.localStorage.getItem("currency_unit")}
                                                                    </div>
                                                                    <div className="col-6"> {tr.description}</div>
                                                                    <div className="col-3 small"> {tr.created_at}</div>

                                                                </div>
                                                            )
                                                    }
                                                        else {
                                                            return(
                                                                <div className='row text-center text-danger py-3 m-auto mt-2 transactions-body  '  >
                                                                    <div className="col-3 fw-bold">
                                                                        {  currencyFormat.format(tr.decrease_amount)}
                                                                        &nbsp;
                                                                        {window.localStorage.getItem("currency_unit")}
                                                                    </div>
                                                                    <div className="col-6"> {tr.description}</div>
                                                                    <div className="col-3 small"> {tr.created_at}</div>

                                                                </div>
                                                            )
                                                        }
                                                })
                                                }

                                            </React.Fragment>
                                            :
                                            <div className="col-12 mt-5 text-center">
                                                <img src={WalletEmpty} alt="Wallet"/>
                                                <div className="text-secondary mt-1 small">
                                                    تراکنشی برای نمایش وجود ندارد.
                                                </div>
                                            </div>
                                    }


                                </div>
                            </section>
                        </div>
                    </div>
                </section>

            </React.Fragment>
        );
    }

    componentDidMount = () => {
        API.walletTransactions()
            .then((response) => {
                this.setState({
                    transactions: response.results.transactions,
                    wallet_inventory: response.results.wallet_inventory
                });

            })
    }
}

export default Wallet;